import { RESERVE_LEGALE_TAUX, RESERVE_LEGALE_PLAFOND_CAPITAL } from '@shared/constants/Taux';
import { roundFCFA } from '@shared/utils/round';

export interface ReserveLegaleCalcul {
  annee: string;
  resultat_apres_is: number;
  capital: number;
  plafond_reserve: number;
  reserve_actuelle: number;
  taux: number;
  dotation_brute: number;
  dotation_effective: number;
  reserve_apres: number;
  plafond_atteint: boolean;
}

/**
 * Calcul de la dotation a la réserve légale (AUSCG Art. 346).
 * - 10 % du résultat après IS
 * - Plafonnée à 20 % du capital social
 * - Obligatoire à partir d'un capital social > 0
 */
export class ReserveLegaleService {
  static calculer(
    annee: string,
    resultat_apres_is: number,
    capital_social: number,
    reserve_actuelle: number,
  ): ReserveLegaleCalcul {
    const plafond_reserve = roundFCFA(capital_social * RESERVE_LEGALE_PLAFOND_CAPITAL);
    const dotation_brute = Math.max(0, roundFCFA(resultat_apres_is * RESERVE_LEGALE_TAUX));
    const dotation_effective = Math.min(
      dotation_brute,
      Math.max(0, plafond_reserve - reserve_actuelle),
    );
    return {
      annee,
      resultat_apres_is: roundFCFA(resultat_apres_is),
      capital: capital_social,
      plafond_reserve,
      reserve_actuelle,
      taux: RESERVE_LEGALE_TAUX,
      dotation_brute,
      dotation_effective,
      reserve_apres: reserve_actuelle + dotation_effective,
      plafond_atteint: reserve_actuelle + dotation_effective >= plafond_reserve,
    };
  }

  /**
   * Helper : calcule la dotation a effectuer pour un exercice donne.
   * Retourne 0 si resultat <= 0 ou plafond atteint.
   */
  static calculerDotation(
    resultat_net: number,
    capital_social: number,
    reserves_existantes: number,
  ): number {
    if (resultat_net <= 0) return 0;
    const r = this.calculer(
      new Date().getFullYear().toString(),
      resultat_net,
      capital_social,
      reserves_existantes,
    );
    return r.dotation_effective;
  }
}
